import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { packageUpgradePopup } from "../../actions/globalAction";
import Modal from "../UIComponents/CustomModal/Modal";
// import { toast } from "react-toastify";
import { withRouter } from "react-router-dom";
import "./LimitComponents.scss";

class UpgradePackageModal extends PureComponent {
    onCancel = () => {
        this.props.packageUpgradePopup();
    };
    upgrade = () => {
        // toast.success("Please contact your account manager regarding package upgrade.");
        this.props.packageUpgradePopup();
        if (this.props.packageUpgradePopupData.path) this.props.history.push(this.props.packageUpgradePopupData.path);
        else this.props.history.push("/billing/plans");
    };
    contact = () => {
        // toast.success("Please contact your account manager regarding package upgrade.");
        this.props.packageUpgradePopup();
        this.props.history.push("/support");
    };
    render() {
        const data = this.props.packageUpgradePopupData || {};
        return (
            <Modal className="upgradePackageModal" show={this.props.packageUpgradePopupData} onClose={this.onCancel}>
                <Modal.Header>{data.name}</Modal.Header>
                <Modal.Content>
                    {data.reason && <p>{data.reason}</p>}
                    {data.message && <p>{data.message}</p>}
                </Modal.Content>
                <Modal.Actions>
                    <Modal.ActionButton normal onClick={this.onCancel}>
                        {data.nonUpgradable ? "OK" : "Cancel"}
                    </Modal.ActionButton>
                    {!data.nonUpgradable &&
                        (data.type === "contact" ? (
                            <Modal.ActionButton filled onClick={this.contact}>
                                Contact Us
                            </Modal.ActionButton>
                        ) : (
                            <Modal.ActionButton filled onClick={this.upgrade}>
                                Upgrade
                            </Modal.ActionButton>
                        ))}
                </Modal.Actions>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => ({
    packageUpgradePopupData: state.globalReducer.packageUpgradePopupData,
});

const mapDispatchToProps = (dispatch) => ({
    packageUpgradePopup: (val) => dispatch(packageUpgradePopup(val)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UpgradePackageModal));
